// extracted by mini-css-extract-plugin
export var addToCartButton = "_tq-b";
export var arrowButtonContainer = "_tq-9";
export var arrowButtonIcon = "_tq-a";
export var carouselArrowButton = "_tq-6";
export var carouselElementContainer = "_tq-1";
export var left = "_tq-7";
export var productDisplayCarouselContainer = "_tq-0";
export var productTileContainer = "_tq-2";
export var productTileImage = "_tq-4";
export var productTileImageContainer = "_tq-3";
export var productTileTitle = "_tq-5";
export var right = "_tq-8";
export var sliderOverflow = "_tq-c";